export default __webpack_public_path__ + "static/media/shaurma.fbf80a0c.png";